"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubModeGestionUtilise = void 0;
exports.ESubModeGestionUtilise = {
    direct: "direct",
    conseillee: "conseillee",
    sous_mandat: "sous_mandat",
};
